import { Link } from 'react-router-dom';

export default function Ashara1448RelayCenter() {
  return (
    <div className="min-h-screen bg-dawoodi-light">
      <section className="bg-gradient-to-br from-dawoodi-navy via-[#10233b] to-[#18324f] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <div className="max-w-3xl">
            <p className="font-poppins text-sm md:text-base uppercase tracking-[0.3em] text-dawoodi-gold mb-4">
              Resources
            </p>
            <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-5">
              Ashara 1448 Relay Center
            </h1>
            <p className="font-poppins text-lg md:text-xl text-white/80 leading-relaxed">
              Relive the spirit of Ashara Mubaraka 1448 with a beautifully presented highlights experience from the New Jersey relay center.
            </p>
          </div>
        </div>
      </section>

      <section className="px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="mx-auto max-w-7xl rounded-[32px] border border-dawoodi-gold/20 bg-white p-3 shadow-[0_20px_80px_rgba(0,0,0,0.12)] md:p-4">
          <div className="overflow-hidden rounded-[24px] bg-black">
            <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
              <iframe
                src="https://player.vimeo.com/video/1207235241?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                title="Highlights from Ashara Mubaraka 1448H - New Jersey Relay Center"
              /> 
            </div>
            <script src="https://player.vimeo.com/api/player.js" />
          </div>
        </div>
      </section>

      <section className="px-4 sm:px-6 lg:px-8 pb-12 md:pb-16">
        <div className="mx-auto max-w-7xl rounded-[32px] border border-dawoodi-gold/20 bg-white p-3 shadow-[0_20px_80px_rgba(0,0,0,0.12)] md:p-4">
          <div className="rounded-[24px] overflow-hidden bg-black">
            <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
              <iframe
                src="https://www.youtube.com/embed/fdmvb8R_gjg"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; encrypted-media; web-share"
                allowFullScreen
                title="1448 Ashara NJ Relay Center Tayyari"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
